import { lazy, Suspense } from 'react'
import { Routes, Route, Navigate } from 'react-router-dom'
import ClaimFormLayout from './components/ClaimFormLayout'
import { useClaimForm } from './context/ClaimFormContext'
import { useAppParams } from './hooks/useAppParams'
import { useClaimLink } from './hooks/useClaimLink'
import { UploadPortalProvider } from './context/UploadPortalContext'
import Step1Route from './steps/Step1Route'
import ExternalScripts from './components/ExternalScripts'

// Lazy-loaded routes — only fetched when navigated to (reduces initial bundle ~200ms TBT)
const Step2TravelData = lazy(() => import('./steps/Step2TravelData'))
const Step3Problem = lazy(() => import('./steps/Step3Problem'))
const StepNoClaim = lazy(() => import('./steps/StepNoClaim'))
const Step4FlightSummary = lazy(() => import('./steps/Step4FlightSummary'))
const Step5Passengers = lazy(() => import('./steps/Step5Passengers'))
const Step6Email = lazy(() => import('./steps/Step6Email'))
const Step7Midpoint = lazy(() => import('./steps/Step7Midpoint'))
const Step8PersonalData = lazy(() => import('./steps/Step8PersonalData'))
const Step9Validation = lazy(() => import('./steps/Step10Validation'))
const Step10Tariff = lazy(() => import('./steps/Step9Tariff'))
const Step11Success = lazy(() => import('./steps/Step11Success'))
const Step12Upload = lazy(() => import('./steps/Step12Upload'))
const UploadLogin = lazy(() => import('./upload/UploadLogin'))
const UploadPortal = lazy(() => import('./upload/UploadPortal'))
const UploadSuccess = lazy(() => import('./upload/UploadSuccess'))
const UploadLayout = lazy(() => import('./upload/UploadLayout'))
const NotFound = lazy(() => import('./components/NotFound'))

function AppInit() {
  useAppParams()
  useClaimLink()
  return <ExternalScripts />
}

function ResumeRedirect() {
  const { data } = useClaimForm()
  return <Navigate to={data.lastReachedStep || '/step1'} replace />
}

function App() {
  return (
    <UploadPortalProvider>
      <AppInit />
      <Suspense fallback={null}>
      <Routes>
      <Route path="upload" element={<UploadLayout />}>
        <Route path="login" element={<UploadLogin />} />
        <Route index element={<UploadPortal />} />
        <Route path="success" element={<UploadSuccess />} />
      </Route>
      <Route path="/" element={<ClaimFormLayout />}>
        <Route index element={<ResumeRedirect />} />
        <Route path="step1" element={<Step1Route />} />
        <Route path="step2" element={<Step2TravelData />} />
        <Route path="step3" element={<Step3Problem />} />
        <Route path="no-claim" element={<StepNoClaim />} />
        <Route path="step4" element={<Step4FlightSummary />} />
        <Route path="step5" element={<Step5Passengers />} />
        <Route path="step6" element={<Step6Email />} />
        <Route path="step7" element={<Step7Midpoint />} />
        <Route path="step8" element={<Step8PersonalData />} />
        <Route path="step9" element={<Step9Validation />} />
        <Route path="step10" element={<Step10Tariff />} />
        <Route path="step11" element={<Step11Success />} />
        <Route path="step12" element={<Step12Upload />} />
      </Route>
      <Route path="*" element={<NotFound />} />
    </Routes>
      </Suspense>
      </UploadPortalProvider>
  )
}

export default App
